<template>
  <v-container fill-height fluid>
    <v-layout justify-center align-start>
      <v-flex xs12 md11>
        <material-card
          icon="mdi-truck"
          color="indigo"
          :title="$t('Pages.Manufacturers.update')"
          :text="$t('Common.enter_details')">
          <v-card-text>
            <manufacturer-form edit @save="update" :manufacturer="manufacturer"></manufacturer-form>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
   <v-layout align-self-start>
      <v-flex>
        <warehouse-transactions manufacturer :warehouses="warehouses"></warehouse-transactions>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import ManufacturerForm from './Form'
  import WarehouseTransactions from  '../warehouses/WarehouseTransactions';

  export default {
    components: {ManufacturerForm, WarehouseTransactions},
    data: () => ({
      manufacturer: {},
      warehouses: []
    }),
    computed: {

    },
    created () {
      this.getManufacturer(this.$route.params.id);
      this.getWarehouses();
    },
    methods: {
      getManufacturer(id){
          this.setFetching(true);
          this.repositories.manufacturer.get(id, 'roles').then(response => {
          this.manufacturer = response.data.data;
        }).finally(() => {
          this.setFetching(false);
        });
      },
      update(data){
        this.repositories.manufacturer.update(this.manufacturer.id, data).then((response) => {
          this.$toast.info(response.data.message);
        });
      },
      getWarehouses(){
        this.repositories.warehouse.all('').then((response) => {
          this.warehouses = response.data.data.filter(el => {
            return el.id != this.$route.params.id;
          });
        })
      },
    }
  }
</script>

<style lang="scss">

</style>
